import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
export interface SpanWithTextBodyCellRendererParams {
  spanClass?: string;
  testSelector?: string;
  textBody: string | null | undefined;
}

@Component({
    selector: 'app-span-with-text-body-cell-renderer',
    template: `<span
    [class]="spanClass"
    [attr.data-test-selector]="testSelector"
    >{{ textBody }}</span
  >`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpanWithTextBodyCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  spanClass?: string;
  testSelector?: string;
  textBody: string | null | undefined;

  agInit({ spanClass, testSelector, textBody }: CustomParams): void {
    this.spanClass = spanClass;
    this.testSelector = testSelector;
    this.textBody = textBody;
    this.changeDetectorRef.detectChanges();
  }
  refresh(): boolean {
    return false;
  }
}
interface CustomParams
  extends ICellRendererParams<unknown, unknown>,
    SpanWithTextBodyCellRendererParams {}
